import {
  CREATE_FIELDS_API,
  CREATE_MAPPINGS_API,
  CREATE_PROFILES_API,
  EXPORT_CUSTOMIZATION_SUMMARY,
  GET_CUSTOMIZATION_PROFILES_API,
  GET_CUSTOMIZATION_PROFILES_SUMMARY_API,
  GET_SUMMARY_FIELDS_API,
  GET_SUMMARY_MAPPINGS_API,
  GET_SUMMARY_PROFILES_API,
  OBSOLETE_SUMMARY_FIELDS_API,
  OBSOLETE_SUMMARY_MAPPINGS_API,
  OBSOLETE_SUMMARY_PROFILES_API,
  UPDATE_FIELD_API,
  UPDATE_MAPPING_API
} from '~/constants/APIs'
import {
  ICustomizationFieldForm,
  ICustomizationFieldObsoleteRequest,
  ICustomizationMapping,
  ICustomizationMappingObsoleteRequest,
  ICustomizationProfile,
  ICustomizationProfileData,
  ICustomizationProfileObsoleteRequest,
  ICustomizationProfileSummary,
  ICustomizationSummarySearchRequest,
  ICustomizationSummarySearchResponse
} from '~/models'

import axiosClient from './axiosClient'

export const customizationProfileApis = {
  createSummaryProfile: (data: ICustomizationProfile) =>
    axiosClient.post(CREATE_PROFILES_API, data),

  createSummaryField: (data: ICustomizationFieldForm) =>
    axiosClient.post(CREATE_FIELDS_API, data),

  updateSummaryField: (data: ICustomizationFieldForm) =>
    axiosClient.patch(UPDATE_FIELD_API, data),

  createSummaryMapping: (data: ICustomizationMapping) =>
    axiosClient.post(CREATE_MAPPINGS_API, data),

  getCustomizationProfiles: () =>
    axiosClient.get(
      GET_CUSTOMIZATION_PROFILES_API
    ) as unknown as ICustomizationProfileData,

  getCustomizationProfilesSummary: () =>
    axiosClient.get(
      GET_CUSTOMIZATION_PROFILES_SUMMARY_API
    ) as unknown as ICustomizationProfileSummary,

  getSummaryFields: (params: ICustomizationSummarySearchRequest) =>
    axiosClient.get(GET_SUMMARY_FIELDS_API, {
      params
    }) as unknown as ICustomizationSummarySearchResponse,

  getSummaryProfiles: (params: ICustomizationSummarySearchRequest | null) =>
    axiosClient.get(GET_SUMMARY_PROFILES_API, {
      params
    }) as unknown as ICustomizationSummarySearchResponse,

  getSummaryMappings: (params: ICustomizationSummarySearchRequest) =>
    axiosClient.get(GET_SUMMARY_MAPPINGS_API, {
      params
    }) as unknown as ICustomizationSummarySearchResponse,

  obsoleteProfiles: (data: ICustomizationProfileObsoleteRequest) =>
    axiosClient.post(OBSOLETE_SUMMARY_PROFILES_API, data),

  obsoleteFields: (data: ICustomizationFieldObsoleteRequest) =>
    axiosClient.post(OBSOLETE_SUMMARY_FIELDS_API, data),

  obsoleteMappings: (data: ICustomizationMappingObsoleteRequest) =>
    axiosClient.post(OBSOLETE_SUMMARY_MAPPINGS_API, data),

  exportSummary: () =>
    axiosClient.get(EXPORT_CUSTOMIZATION_SUMMARY, {
      params: { downloadId: 1 },
      responseType: 'blob'
    }),
  updateMapping:(data: ICustomizationMapping) =>
    axiosClient.patch(UPDATE_MAPPING_API, data),
}
